import React, { createContext, useContext } from 'react';

const RadioButtonContext = createContext(null);

export function useRadioButtonContext() {
  const radioButton = useContext(RadioButtonContext);

  if (!radioButton) {
    throw new Error('RadioButtonProvider is missing');
  }

  return radioButton;
}

export function RadioButtonProvider({ radioButton, children }) {
  return (
    <RadioButtonContext.Provider value={radioButton}>
      {children}
    </RadioButtonContext.Provider>
  );
}
